import { createContext, useContext, ReactNode } from 'react';
import { useShowroundManager, ShowroundManager } from '../hooks/use-showround-manager';

const ShowroundContext = createContext<ShowroundManager | null>(null);

interface ShowroundProviderProps {
  children: ReactNode;
  supplierId: string;
  enabled?: boolean;
}

export function ShowroundProvider({ children, supplierId, enabled }: ShowroundProviderProps) {
  const showroundManager = useShowroundManager({ supplierId, enabled });

  return <ShowroundContext.Provider value={showroundManager}>{children}</ShowroundContext.Provider>;
}

export function useShowroundContext(): ShowroundManager {
  const context = useContext(ShowroundContext);

  if (!context) {
    throw new Error(
      'useShowroundContext must be used within a ShowroundProvider. ' +
        'Make sure your component is wrapped with <ShowroundProvider>.',
    );
  }

  return context;
}
